// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import {
  CustomFieldDefinition,
  type CustomFieldDefinitionWireFormat,
  NewCustomFieldDefinition,
} from '../CustomFieldDefinition/CustomFieldDefinition';

export class PlantCustomField {
  readonly definition: CustomFieldDefinition;
  readonly value: string | null;

  constructor(data: { [key: string]: any } = {}) {
    this.definition = NewCustomFieldDefinition(data.definition);
    this.value = data.value === undefined ? null : data.value;
  }

  static zero(): PlantCustomField {
    const zeroValues: ExcludeMethodsDeep<PlantCustomField> = {
      definition: CustomFieldDefinition.zero(),
      value: null,
    };
    return new PlantCustomField(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type PlantCustomFieldWireFormat = {
  definition: CustomFieldDefinitionWireFormat;
  value: string | null;
};

type NewPlantCustomFieldProps = PartialDeep<PlantCustomField, { recurseIntoArrays: true }>;
export const NewPlantCustomField: (props: NewPlantCustomFieldProps) => PlantCustomField = (props) =>
  new PlantCustomField(props);

type NewPlantCustomFieldFromWireFormatProps = PartialDeep<
  PlantCustomFieldWireFormat,
  { recurseIntoArrays: true }
>;
export const NewPlantCustomFieldFromWireFormat: (
  props: NewPlantCustomFieldFromWireFormatProps,
) => PlantCustomField = (props) => new PlantCustomField(props);
